import type { Components, Theme } from '@mui/material';

export const MuiListItemText: Components<Omit<Theme, 'components'>>['MuiListItemText'] = {
  styleOverrides: {
    root: {
      fontSize: '14px !important',
    },
    primary: {
      fontSize: '14px !important',
    },
    secondary: {
      fontSize: '14px !important',
    },
  },
};
